var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsegnataBlu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 56",
    style: {
      enableBackground: "new 0 0 51 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001A4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.8,24.3c-4.9,0-8.7-6.6-8.7-15c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1c0,7.1,3.1,13,6.7,13s6.7-6,6.7-13 c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1C30.4,17.8,26.6,24.3,21.8,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.6,9.3c-0.5,0-1-0.4-1-1V2c0-0.1-0.1-0.2-0.1-0.2H14.1C14,1.9,14,1.9,14,2v6.3c0,0.5-0.4,1-1,1 c-0.5,0-1-0.4-1-1V2c0-1.2,0.9-2.1,2.1-2.1h15.4c1.2,0,2.1,1,2.1,2.1v6.3C31.6,8.9,31.1,9.3,30.6,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.4,9.3H13c-0.5,0-1-0.4-1-1c0-0.5,0.4-1,1-1h24.3c0.5,0,1,0.4,1,1C38.4,8.9,37.9,9.3,37.4,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,55.6H1.2c-0.3,0-0.5-0.1-0.7-0.3s-0.3-0.5-0.3-0.7C0.3,54,1,38.8,6.8,31c2.5-3.3,9.6-5.9,9.9-6 c0.5-0.2,1.1,0.1,1.2,0.6c0.2,0.5-0.1,1.1-0.6,1.2c-0.1,0-6.9,2.5-9,5.3c-4.6,6.2-5.8,18-6.1,21.5H20c0.5,0,1,0.4,1,1 S20.5,55.6,20,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.5,29.4c-0.2,0-0.4-0.1-0.5-0.2c-2.4-1.6-5.1-2.3-5.1-2.3c-0.5-0.1-0.8-0.7-0.7-1.2 c0.1-0.5,0.7-0.8,1.2-0.7c0.1,0,3,0.8,5.7,2.6c0.4,0.3,0.6,0.9,0.3,1.4C33.1,29.3,32.8,29.4,32.5,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50,55.6H24.5c-0.5,0-1-0.4-1-1v-22c0-0.5,0.4-1,1-1H50c0.5,0,1,0.4,1,1v22C51,55.2,50.6,55.6,50,55.6z  M25.5,53.6H49v-20H25.5V53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.9,38.3h-9.3c-0.5,0-1-0.4-1-1V33c0-0.5,0.4-1,1-1c0.5,0,1,0.4,1,1v3.3h7.3V33c0-0.5,0.4-1,1-1 c0.5,0,1,0.4,1,1v4.3C42.9,37.9,42.4,38.3,41.9,38.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.3,
    y: 49.8,
    className: "st0",
    width: 2.2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.1,
    y: 49.8,
    className: "st0",
    width: 2.2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9.8,55.3L9.8,55.3c-0.5,0-1-0.4-1-1V40.9c0-0.5,0.4-1,1-1l0,0c0.5,0,1,0.4,1,1v13.4 C10.8,54.9,10.3,55.3,9.8,55.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsegnataBlu);
export default __webpack_public_path__ + "static/media/consegnataBlu.0b081f20.svg";
export { ForwardRef as ReactComponent };